import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-line bg-forest-dark text-cream" data-id="element-80" data-mp="3ggk6ap6ov1ww">
      <div className="mx-auto grid max-w-6xl gap-10 px-5 py-14 md:grid-cols-[1.4fr_1fr_1fr]" data-id="element-81" data-mp="32ovvcp86ejhi">
        <div data-id="element-82" data-mp="36qhhl16loa4d">
          <p className="font-display text-xl" data-id="element-83" data-mp="36q900vzj8gmu">Plaisir d'Offrir</p>
          <p className="mt-3 max-w-sm text-sm leading-relaxed text-cream/70" data-id="element-84" data-mp="3ueiltxwqx4dz">
            Atelier français d'horloges décoratives personnalisées. Impression haute définition sur
            support rigide, mécanisme silencieux, assemblage à la main.
          </p>
          <Link to="/personnaliser" className="mt-6 inline-flex rounded-full bg-cream px-5 py-2.5 text-sm font-medium text-forest-dark transition-colors duration-150 ease-out hover:bg-white" data-id="element-85" data-mp="3lgopimyzeaqt">
            Créer mon horloge
          </Link>
        </div>

        <div data-id="element-86" data-mp="2ezl0tphf5lbt">
          <h2 className="text-xs uppercase tracking-[0.2em] text-cream/50" data-id="element-87" data-mp="2evxaez79tf1b">Le site</h2>
          <ul className="mt-4 space-y-2.5 text-sm text-cream/80" data-id="element-88" data-mp="3lbmtfq7jj4eu">
            <li data-id="element-89" data-mp="3gbr0cm0dsxe2">
              <Link className="hover:text-white" to="/modeles" data-id="element-90" data-mp="3gca7d7ohu1db">
                Nos modèles
              </Link>
            </li>
            <li data-id="element-91" data-mp="3q8mzi14e475y">
              <Link className="hover:text-white" to="/personnaliser" data-id="element-92" data-mp="3q8wts0wgx0hg">
                Personnaliser
              </Link>
            </li>
            <li data-id="element-93" data-mp="81pejgi0et8b">Livraison &amp; délais</li>
            <li data-id="element-94" data-mp="33xdnwzdzwrz">Conditions générales</li>
          </ul>
        </div>

        <div data-id="element-95" data-mp="33nlc2qvddj4">
          <h2 className="text-xs uppercase tracking-[0.2em] text-cream/50" data-id="element-96" data-mp="31up7hdvubpd">Contact</h2>
          <ul className="mt-4 space-y-3 text-sm text-cream/80" data-id="element-97" data-mp="hs1x5369kcbt">
            <li className="flex items-center gap-2.5" data-id="element-98" data-mp="cus0p3kgj0eh">
              <PhoneIcon className="h-4 w-4 shrink-0 text-cream/50" aria-hidden="true" data-id="element-99" data-mp="cw36ta1dkk8r" />
              02 41 00 00 00
            </li>
            <li className="flex items-center gap-2.5" data-id="element-100" data-mp="mspnrnqkyr5i">
              <MailIcon className="h-4 w-4 shrink-0 text-cream/50" aria-hidden="true" data-id="element-101" data-mp="mq3glp7lqdnt" />
              bonjour@plaisirdoffrir.fr
            </li>
            <li className="flex items-start gap-2.5" data-id="element-102" data-mp="ytejsg6pcas7">
              <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-cream/50" aria-hidden="true" data-id="element-103" data-mp="yrv16ixkpnn9" />
              Atelier de Saumur, Maine-et-Loire
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-cream/10 py-5 text-center text-xs text-cream/50" data-id="element-104" data-mp="18lu0792coraz">
        © {new Date().getFullYear()} Plaisir d'Offrir — Fabriqué en France
      </div>
    </footer>;
}